import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { AUTHENTICATE_STATUS, defaultPaging } from '@/common/constants/ConstCode';

const state = {
  detail: {},
  jobDetail: {},
  recentSearch: [],
  kakaoPageableCount: 0,
  coordinateChange: false,
  kakaoSearchText: null,
  categorySearchFlag: false,
  condition: {
    searchText: '',
    userNo: '',
    ...defaultPaging
  },
  addressCondition: {
    userNo: '',
    ...defaultPaging
  },
  likeCondition: {
    userNo: '',
    ...defaultPaging
  },
  purchaseCondition: {
    userNo: '',
    ...defaultPaging
  },
  marketingRegister: {
    businessNo: '',
    title: '',
    contents: '',
    imageList: [],
    eventStartDate: '',
    eventEndDate: '',
    deleteList: []
  },
  donationRegister: {
    businessNo: '',
    title: '',
    contents: '',
    imageList: [],
    startDate: '',
    endDate: '',
    deleteList: []
  },
  jobRegister: {
    businessNo: '',
    title: '',
    contents: '',
    startDate: '',
    endDate: '',
    deleteList: []
  },
  register: {
    userNo: '',
    businessNo: '',
    isAgreeMarketing: false,
    businessCategoryNo: '',
    name: '',
    userSelectedType: '',
    address: '',
    roadAddress: '',
    addressDetail: '',
    imageList: [],
    tags: [],
    isGlobal: false,
    isPray: true,
    licenseNumber: '',
    authenticateStatus: AUTHENTICATE_STATUS.WAITING.key,
    openTime: '',
    closeTime: '',
    offDays: [],
    phone: '',
    introduce: '',
    logoImage: null,
    latitude: '',
    longitude: '',
    buildingName: '',
    isChristian: false
  },
  categoryList: [],
  productList: [],
  businessList: [],
  businessSearchList: [],
  businessPreviewList: [],
  addressList: [],
  likeList: [],
  purchaseList: [],
  // 260429: 마이페이지 전용 격리 — 메인 피드의 businessList와 완전 분리
  myBusinessList: [],
  myCondition: {
    userNo: '',
    ...defaultPaging
  },
  myPageInfo: { ...defaultPaging },
  searchText: '',
  // 좌표 검색시 사용하는 데이터
  coordinate: { latitude: 37.4986655, longitude: 127.027028, isOneKM: true },
  pageInfo: { ...defaultPaging },
  purchasePageInfo: { ...defaultPaging },
  addressPageInfo: { ...defaultPaging },
  likePageInfo: { ...defaultPaging },
  searchPageInfo: { ...defaultPaging },
  selectAddress: { address: '서울 서초구 서초동' },
  markerPin: {},
  registerPin: {},
  marketingTicketCount: 0,
  addressSearchText: '',
  // 현재 위치를 필요로하는곳에서 사용하기 위해 저장하는 데이터
  fixCoordinate: {},
  isLocationModal: true,
  signboardFeedList: [],
  signboardDetail: {},
  // 공유→충전 모드: 간판 관리에서 "공유하고 충전" 누르면 내 businessNo 저장
  // 다른 업체 detail에서 카카오 공유 시 chargeBattery API 호출
  signboardChargeMode: null,
  overseasFilter: false,
  // 260522: 검색 결과 네이버 미가입 ghost 카드 mix-in (똑딱 모델). searchText 있고 page=1일 때만 채워짐
  ghostList: [],
  // 260618: GPS 현재위치 좌표 별도 보관 — 로그인 시 getSelectAddress가 coordinate를 대표주소로 덮어도
  //          유령기업 카카오 검색은 항상 GPS 실위치 기준이 되도록. null이면 coordinate fallback.
  gpsCoordinate: null
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
